import * as fs from 'node:fs';
import * as path from 'node:path';
import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';
import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import { DISK_WALK_YIELD_EVERY, type DiskWalkState } from './disk-walk-constants.js';

export async function yieldDuringDiskWalk(state: DiskWalkState): Promise<boolean> {
  state.entries++;
  if (state.entries % DISK_WALK_YIELD_EVERY !== 0) return true;
  if (isCliImmediateShutdownRequested()) return false;
  await yieldToEventLoop();
  return !isCliImmediateShutdownRequested();
}

export async function isGitDir(dirPath: string): Promise<boolean> {
  try {
    await fs.promises.access(path.join(dirPath, '.git'));
    return true;
  } catch {
    return false;
  }
}
